import React, {useState} from 'react';
import {
  CenteredSpaceWrap,
  PrimaryLink,
} from '../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
import GoSafeLogoIcon from '../../../../../../stories/Icons/GoSafeLogoIcon';
import GoSafeSheildLogo from '../../../../../../stories/Icons/goSafeSheildLogo';
import GoSafeDetailedPersuasion from '../../../../../../stories/components/hotels/SRP/GoSafeDetailedPersuasion/GoSafeDetailedPersuasion';
import * as S from './GoSafeTagPersuasion.styles';

type GoSafeTagPersuasionType = {
  data: {
    htd: {
      ht: Array<string>;
      iu: string;
      ft: string;
      ftc: string;
      hoc: {
        bgc: string;
        tc: string;
      };
    };
    ccd: {
      bgc: string;
      tc: string;
    };
    iu: string;
    fd: {tag: string};
    pt: string;
  };
  onCtaClick?: Function;
  gaHandler?: Function;
  showFull?: boolean;
  positionTop?: boolean;
};

const GoSafeTagPersuasion = ({
  data,
  onCtaClick = () => {},
  gaHandler,
  showFull = false,
  positionTop = false,
}: GoSafeTagPersuasionType) => {
  const [open, setOpen] = useState(false);
  if (!(data && data.htd && data.htd.ht && data.iu)) return null;
  const {
    htd,
    iu: mainImage = '',
    fd: filterData,
    pt: mainMessage = '',
    ccd = {bgc: '', tc: ''},
  } = data;
  const {
    ht = [],
    iu: hoverImage = '',
    ft: hoverFilterText = '',
    ftc = '',
    hoc = {bgc: '', tc: ''},
  } = htd;
  return (
    <S.GoSafeTagContainer onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
      {(showFull && (
        <GoSafeDetailedPersuasion mainImage={mainImage} message={mainMessage} colorCodes={ccd} />
      )) || <S.GosafeImg src={mainImage} width="5.8rem" />}
      {open && (
        <S.GoSafeDropDownOuter positionTop={positionTop}>
          <S.TipPositioning positionTop={positionTop} />
          <S.GoSafeDropDownHover positionTop={positionTop} backgroundColor={hoc?.bgc}>
            <CenteredSpaceWrap>
              <ul>
                {ht.map((item, index) => (
                  <S.GoSafeDropDownItem key={`${item}-${Math.random()}-${index}`}>
                    <S.TickIconWrap />
                    <S.GoSafeDropDownItemText textColor={hoc?.tc}>{item}</S.GoSafeDropDownItemText>
                  </S.GoSafeDropDownItem>
                ))}
              </ul>
              {(!!hoverImage && (
                <S.GosafeImg src={hoverImage} width="8.8rem" height="10.4rem" />
              )) || <GoSafeSheildLogo width="8.8rem" height="10.4rem" />}
            </CenteredSpaceWrap>
            {!!filterData && hoverFilterText && (
              <PrimaryLink
                onClick={e => {
                  e.stopPropagation();
                  gaHandler(hoverFilterText, JSON.stringify(filterData));
                  onCtaClick(filterData);
                }}
                color={ftc}
              >
                {hoverFilterText || 'Show goSafe Properties'}
              </PrimaryLink>
            )}
          </S.GoSafeDropDownHover>
        </S.GoSafeDropDownOuter>
      )}
    </S.GoSafeTagContainer>
  );
};

export default GoSafeTagPersuasion;
